import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getAddLanguageFormValidation(t: TFunction) {
  return yup.object({
    key: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.keyRequired')),
    title: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.titleRequired')),
  });
}
